<template>
    <div class="section-layout-wrapper" v-if="data && reArrangeElements && reArrangeElements.length > 0">
        <slot :name="'innerSection' + sectionIndex" v-for="(section, sectionIndex ) in   data.sectionsExpanded  "
            :key="sectionIndex" :data="section" :componentIndex="sectionIndex
                ">
            <section v-if="section" class="section" :class="section.settings.class" :data-section-index="sectionIndex"
                :data-template-name="'innerSection' + sectionIndex">
                <span class=" anchor" :id="section.settings.anchorPoint"></span>
                <div class="container">
                    <!-- Collection content i.e. TemplateContent -->
                    <div class="column-wrapper" v-if="section.contentCollection && section.contentCollection.length > 0">
                        <div class="collection" :class="['column ' + getContentType(section.contentCollection)]">

                            <div class="items-wrapper">
                                <ul>
                                    <li v-for="( element, elementIndex  ) in  section.contentCollection" :key="elementIndex"
                                        :class="getContentType(section.contentCollection)">
                                        <SingleTemplateContent :data="element.templateContent"
                                            :contentType="element.contentName.toString().toLowerCase()" />
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                    <!-- Std -->
                    <div class="column-wrapper"
                        v-else-if="section.elements && section.elements.length > 0 && section.contentCollection && section.contentCollection.length == 0">
                        <div :class="['column ' + element.entityType.toLowerCase(), addComponentNameAsClass(element)]"
                            v-for="(  element, elementIndex   ) in   section.elements  " :key="elementIndex">

                            <PlayList
                                v-if="element.entityType === 'Playlist' && checkElemenDeep(element.playList.relatedContents).includes('VideoContent')"
                                :playlistExpanded="element.playList" />

                            <ContentPlayList
                                v-if="element.entityType === 'Playlist' && checkElemenDeep(element.playList.relatedContents).includes('TemplateContent')"
                                :data="element.playList" :contentType="getContentType(element.playList.relatedContents)" />

                            <!-- Component -->
                            <ContentColumn
                                v-if="element.entityType === 'TemplateContent' && element.contentType === 'Component'"
                                :data="element" />

                            <!-- Price plan -->
                            <div v-if="element.entityType == 'Priceplan'" class="items-wrapper subscription">
                                <SubscriptionOverviewItem :data="element" />
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </slot>
    </div>
</template>

<script>
//import { fetchCmsMedia } from "@streampac.io/chef_sp_1";

import { defineAsyncComponent } from "vue";

const PlayList = defineAsyncComponent(() => import("@/components/PageLayoutBuilder/Partials/Video/PlayList"));
const ContentColumn = defineAsyncComponent(() => import("@/components/PageLayoutBuilder/Partials/Content/ContentColumn"));
const ContentPlayList = defineAsyncComponent(() => import("@/components/PageLayoutBuilder/Partials/Content/ContentPlayList"));
const SubscriptionOverviewItem = defineAsyncComponent(() => import("@/components/SubscriptionOverviewItem"));

const SingleTemplateContent = defineAsyncComponent(() => import("@/components/PageLayoutBuilder/Partials/Content/SingleTemplateContent"));

export default {
    data() {
        return {
            addedClassesThroughTemplate: [],
            contentTypeArray: [],
        };
    },
    computed: {
        reArrangeElements: function () {
            return this.data.sectionsExpanded.filter(function (section) {

                if (section.elements && section.elements.length > 0) {
                    let elementConversionArray = [];

                    section.elements.forEach((element) => {
                        if (element.entityType === 'TemplateContent' && element.contentType === 'Page') {
                            elementConversionArray.push(element);
                        }
                    });

                    return section.contentCollection = elementConversionArray;

                }
            });

        },
    },
    components: {
        PlayList,
        ContentColumn,
        ContentPlayList,
        SubscriptionOverviewItem,
        SingleTemplateContent
    },
    mounted() {
        if (this.data) {
            //console.log(this.data);
            // this.data.sectionsExpanded.forEach((section, index) => {
            //     console.log(section);
            //     this.addedClassesThroughTemplate.push(index);
            // });
        }
        //console.log(this.reArrangeElements);
    },
    props: ['data', 'addSectionClass'],
    inject: ["isAuthenticated"],
    methods: {
        groupByList(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);
                if (!collection) {
                    map.set(key, [item]);
                } else {
                    collection.push(item);
                }
            });
            return map;
        },
        parseHtml(passedHtml) {
            return passedHtml.replaceAll(
                'rel="noopener noreferrer" target="_blank"',
                ""
            );
        },
        checkElemenDeep(elem) {
            if (elem) {
                const pluck = (array, key) => {
                    return array.map((o) => o[key]);
                };

                const unique = (array) => {
                    return array.filter(function (el, index, arr) {
                        return index == arr.indexOf(el);
                    });
                };

                const pluckFields = pluck(elem, "entityType");
                const uniqueVals = unique(pluckFields);

                return uniqueVals;
            } else {
                return [];
            }
        },
        getContentType(elem) {
            const pluck = (array, key) => {
                return array.map((o) => o[key]);
            };

            const unique = (array) => {
                return array.filter(function (el, index, arr) {
                    return index == arr.indexOf(el);
                });
            };

            const pluckFields = pluck(elem, "contentName");
            const uniqueVals = unique(pluckFields);

            return uniqueVals.toString().toLowerCase();
        },
        addComponentNameAsClass(elem) {
            if (elem.entityType === 'Playlist') {
                if (elem.playList) {
                    return this.getContentType(elem.playList.relatedContents);
                }
            } else if (elem.entityType === 'TemplateContent' && elem.contentType !== 'Component') {
                return elem.contentName.toString().toLowerCase();

            } else {
                return '';
            }
        },
    }

};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>

<style lang="scss">
// @import styles
@import "./index-unscoped.scss";
</style>
